// @flow
import type { InstructorI as APIInstructorI } from 'redux/interfaces/api/InstructorI';
import type { EntityRecordI } from './EntityRecord';
import EntityRecord from './EntityRecord';

export const parseInstructorJsonToEntity = (
  instructorJson: APIInstructorI,
  originalRecord: EntityRecordI
): EntityRecordI => {
  const existingValues = originalRecord.toJS() || {};

  const record = new EntityRecord({
    ...existingValues,
    instructorSlug: instructorJson.data.attributes.slug || ''
  });
  // $FlowFixMe, prop check is unnecessary, as immutable record always returns all props
  return record;
};
